import Vue from 'vue'
import App from './App.vue'
import request from '@/libs/request.js'
import router from '@/libs/router.js'
import '@/assets/index.scss'
import store from './store'
import { Pagination,Image,Message } from 'element-ui'

Vue.config.productionTip = false

Vue.prototype.$request = request

Vue.prototype.$message = Message

import DOMPurify from 'dompurify';
Vue.prototype.$sanitize=function (html) {
  return DOMPurify.sanitize(html);
}

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
// 使用swiper插件
Vue.use(VueAwesomeSwiper)

import VueMeta from 'vue-meta';

Vue.use(VueMeta);

Vue.use(Pagination)
Vue.use(Image)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
